import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import { useEffect } from "react";
import { trackDashboardScreenView } from "@apps/dashboard/lib/analytics";

export function AnimatedOutlet(): JSX.Element {
  const location = useLocation();
  const prefersReducedMotion = useReducedMotion();
  const screenPath = `${location.pathname}${location.search}`;

  useEffect(() => {
    trackDashboardScreenView(screenPath);
  }, [screenPath]);

  if (prefersReducedMotion) {
    return <Outlet />;
  }

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -6 }}
        transition={{ duration: 0.26, ease: [0.22, 1, 0.36, 1] }}
        className="h-full"
      >
        <Outlet />
      </motion.div>
    </AnimatePresence>
  );
}
